export const listaEstadoCivil = [
    {Id: 'C', Descricao: 'Casado'},
    {Id: 'S', Descricao: 'Solteiro'},
    {Id: 'D', Descricao: 'Divorciado'},
];

export const listaSexo = [
    {Id: 'F', Descricao: 'Feminino'},
    {Id: 'M', Descricao: 'Masculino'}
];

export const listaSimNao = [
    {Id: 'S', Descricao: 'Sim'},
    {Id: 'N', Descricao: 'Não'}
];

export const listaSituacao = [
    {Id: 'A', Descricao: 'Ativo'},
    {Id: 'I', Descricao: 'Inativo'},
    {Id: 'B', Descricao: 'Bloqueado'}
];

export const listaEstadosAndamento = [
    {Id: 1, DescricaoEstadosAndamento: 'Pendente'},
    {Id: 2, DescricaoEstadosAndamento: 'Agendamento'},
    {Id: 3, DescricaoEstadosAndamento: 'Procedente SIM'},
    {Id: 4, DescricaoEstadosAndamento: 'Procedente NÃO'},
    {Id: 5, DescricaoEstadosAndamento: 'Recorrente'},
    {Id: 6, DescricaoEstadosAndamento: 'Finalizado'},
    {Id: 7, DescricaoEstadosAndamento: 'Cancelado'},
    {Id: 8, DescricaoEstadosAndamento: 'Em Atendimento'}
];




// WEBPACK FOOTER //
// ./src/app/shared/listas-parametros.ts